import "../src/assets/scss/css/styles.min.css";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Header from "./components/Header";
import Services from "./components/Services";
import About from "./components/About";
import { Contact } from "./components/Contact";
import Offers from "./components/Offers";

function App() {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      <Navbar />
      <Header />
      <About />
      <Services />
      {/* <Projects /> */}
      <Offers/>
      <Contact />
      <Footer />
    </>
  );
}

export default App;
